import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 370C68CC-A001-4368-9617-B7D683361B27
 * name flag-minus-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-minus-outline.svg
 * tags
 */
export const FlagMinusOutlineIcon = createSvgIcon(<><path d="M12.36 6L12.76 8H18V14H14.64L14.24 12H7V6H12.36M14 4H5V21H7V14H12.6L13 16H20V6H14.4M23 18H15V20H23V18Z" /></>, 'FlagMinusOutlineIcon');
export default FlagMinusOutlineIcon